import { render, staticRenderFns } from "./DeleteFolderDialog.vue?vue&type=template&id=3ef6c3c8&scoped=true&"
import script from "./DeleteFolderDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteFolderDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteFolderDialog.vue?vue&type=style&index=0&id=3ef6c3c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6c3c8",
  null
  
)

export default component.exports